// This file is auto-generated by @hey-api/openapi-ts
import * as z from 'zod';
import { client } from './client.gen';
import { zAddScenePropBody, zAddScenePropResponse, zAnswerSceneBody, zAnswerScenePath, zAnswerSceneResponse, zAppendLessonsBody, zAppendLessonsPath, zAppendLessonsResponse, zAppendModulesBody, zAppendModulesPath, zAppendModulesResponse, zApplyFindingPath, zApplyFindingResponse, zApplyLessonFixPath, zApplyLessonFixResponse, zApplyLessonRenamePath, zApplyLessonRenameResponse, zApplyLessonRenamesResponse, zApplyModuleRenamePath, zApplyModuleRenameResponse, zApplyModuleRenamesResponse, zApplyPlanningProposalsBody, zApplyPlanningProposalsResponse, zApplyRecastPath, zApplyRecastResponse, zApplyStoryProposalBody, zApplyStoryProposalResponse, zApplyVisualFixPath, zApplyVisualFixResponse, zApproveSceneImagePath, zApproveSceneImageResponse, zArchiveLessonsBody, zArchiveLessonsResponse, zAskCurriculumBody, zAskCurriculumResponse, zAskPlannerBody, zAskPlannerResponse, zAskSuggestionsPath, zAskSuggestionsQuery, zAskSuggestionsResponse, zAskTrainHelpBody, zAskTrainHelpPath, zAskTrainHelpResponse, zAskTutorBody, zAskTutorPath, zAskTutorResponse, zAttachLessonSourceBody, zAttachLessonSourcePath, zAttachLessonSourceResponse, zAttemptLessonPath, zAttemptLessonResponse, zAttentionQuery, zAttentionResponse, zBrowseCollectionsQuery, zBrowseCollectionsResponse, zBrowseLessonsQuery, zBrowseLessonsResponse, zBuildPlannedLessonsBody, zBuildPlannedLessonsResponse, zCancelGenerationPath, zCancelGenerationResponse, zCancelPlannedLessonBuildPath, zCancelPlannedLessonBuildResponse, zCheckLessonSourcesBody, zCheckLessonSourcesPath, zCheckLessonSourcesResponse, zChooseSceneImageBody, zChooseSceneImagePath, zChooseSceneImageResponse, zCollectionLessonsPath, zCollectionLessonsResponse, zCollectionPublishReadinessPath, zCollectionPublishReadinessResponse, zCompleteAttemptBody, zCompleteAttemptPath, zCompleteAttemptResponse, zCreateCollectionBody, zCreateCollectionResponse, zCreateLessonBody, zCreateLessonResponse, zCreatePlannedCourseBody, zCreatePlannedCourseInAppPath, zCreatePlannedCourseInAppResponse, zCreatePlannedCourseResponse, zCreatePlannedInAppBody, zCreatePlannedInAppResponse, zCreatePlannedLessonBody, zCreatePlannedLessonResponse, zCreatePlannedModuleBody, zCreatePlannedModuleInAppPath, zCreatePlannedModuleInAppResponse, zCreatePlannedModuleResponse, zCreateQuestionBody, zCreateQuestionResponse, zCreateSceneBody, zCreateSceneResponse, zCreateSourceBody, zCreateSourceResponse, zDeleteCurriculumDatasetResponse, zDeletePlannedCoursePath, zDeletePlannedCourseResponse, zDeletePlannedLessonPath, zDeletePlannedLessonQuery, zDeletePlannedLessonResponse, zDeletePlannedModulePath, zDeletePlannedModuleResponse, zDeleteTrainSessionPath, zDeleteTrainSessionResponse, zDescribePlanningScopeBody, zDescribePlanningScopeResponse, zDetachLessonSourcePath, zDetachLessonSourceResponse, zDiscardFindingPath, zDiscardFindingResponse, zDiscardLessonFixPath, zDiscardLessonFixResponse, zDiscardRecastPath, zDiscardRecastResponse, zDiscardRewritePath, zDiscardRewriteResponse, zDiscardVisualFixPath, zDiscardVisualFixResponse, zDismissFindingPath, zDismissFindingResponse, zDrawOnboardingArtBody, zDrawOnboardingArtResponse, zDropMyStreakGoalQuery, zDropMyStreakGoalResponse, zEndTrainSessionPath, zEndTrainSessionResponse, zExportPlannedLessonsQuery, zExportPlannedLessonsResponse, zFileSupportRequestBody, zFileSupportRequestResponse, zFillCoursePath, zFillCourseResponse, zFindExistingCollectionsBody, zFindExistingCollectionsResponse, zFixModuleBody, zFixModulePath, zFixModuleResponse, zFixSceneFieldBody, zFixSceneFieldPath, zFixSceneFieldResponse, zForgetScenePath, zForgetSceneResponse, zForgetTermPath, zForgetTermResponse, zGenerateSceneImageBody, zGenerateSceneImagePath, zGenerateSceneImageResponse, zGetAiAllowanceResponse, zGetAuthoringCollectionPath, zGetAuthoringCollectionResponse, zGetBadgesQuery, zGetBadgesResponse, zGetCollectionPath, zGetCollectionProgressPath, zGetCollectionProgressResponse, zGetCollectionResponse, zGetCollectionSharePath, zGetCollectionShareResponse, zGetConsultantThreadPath, zGetConsultantThreadResponse, zGetExploreQuery, zGetExploreResponse, zGetGenerationPath, zGetGenerationPatternsQuery, zGetGenerationPatternsResponse, zGetGenerationPromptPath, zGetGenerationPromptResponse, zGetGenerationResponse, zGetHealthResponse, zGetHomeQuery, zGetHomeResponse, zGetLessonCoverPath, zGetLessonCoverResponse, zGetLessonPath, zGetLessonResponse, zGetLessonSharePath, zGetLessonShareResponse, zGetMeResponse, zGetMyOnboardingResponse, zGetMyStreakGoalQuery, zGetMyStreakGoalResponse, zGetOnboardingCopyCatalogResponse, zGetOnboardingOptionsResponse, zGetPicturePath, zGetPictureResponse, zGetPlannedLessonDetailsPath, zGetPlannedLessonDetailsQuery, zGetPlannedLessonDetailsResponse, zGetPlannedLessonPlacementPath, zGetPlannedLessonPlacementResponse, zGetPlannedModuleStoryPath, zGetPlannedModuleStoryResponse, zGetReadinessResponse, zGetScenarioPath, zGetScenarioResponse, zGetSceneImageFilePath, zGetSceneImageFileQuery, zGetSceneImageFileResponse, zGetShortSharePath, zGetShortShareResponse, zGetShortsQuery, zGetShortsResponse, zGetTrainSessionPath, zGetTrainSessionResponse, zGetVerificationPath, zGetVerificationResponse, zGradeFirstChallengeBody, zGradeFirstChallengePath, zGradeFirstChallengeResponse, zImportCurriculumBody, zImportCurriculumResponse, zKeepFindingPath, zKeepFindingResponse, zLessonFeedbackPath, zLessonFeedbackResponse, zLessonPublishReadinessPath, zLessonPublishReadinessResponse, zLessonResearchPath, zLessonResearchResponse, zLessonResumePath, zLessonResumeResponse, zListCastResponse, zListCollectionsQuery, zListCollectionsResponse, zListConsultantThreadsResponse, zListGenerationLedgerQuery, zListGenerationLedgerResponse, zListGenerationsResponse, zListJobVerificationsPath, zListJobVerificationsResponse, zListLessonBookmarksPath, zListLessonBookmarksResponse, zListLessonFixesPath, zListLessonFixesResponse, zListLessonRenamesResponse, zListLessonReviewsPath, zListLessonReviewsResponse, zListLessonSavedTermsPath, zListLessonSavedTermsResponse, zListLessonSourceChecksPath, zListLessonSourceChecksResponse, zListLessonsQuery, zListLessonsResponse, zListLessonVerificationsPath, zListLessonVerificationsResponse, zListModuleRenamesResponse, zListOnboardingConfigsResponse, zListPlannedCoursesResponse, zListPlannedLessonsQuery, zListPlannedLessonsResponse, zListPlannedLessonVersionsPath, zListPlannedLessonVersionsResponse, zListPlanningRevisionsQuery, zListPlanningRevisionsResponse, zListSavedScenesQuery, zListSavedScenesResponse, zListSavedTermsQuery, zListSavedTermsResponse, zListScenariosQuery, zListScenariosResponse, zListSceneImagesPath, zListSceneImagesResponse, zListSystemPromptsResponse, zListTagsResponse, zListTopicsResponse, zListTrainCounterpartsResponse, zListTrainSessionsResponse, zListTrainStartersResponse, zListVisualFixesPath, zListVisualFixesResponse, zMarkMyStreakEventsSeenBody, zMarkMyStreakEventsSeenQuery, zMarkMyStreakEventsSeenResponse, zMarkShortSeenBody, zMarkShortSeenPath, zMarkShortSeenResponse, zMoveAppLessonToMatchPlanPath, zMoveAppLessonToMatchPlanResponse, zNextPlannedLessonIdPath, zNextPlannedLessonIdResponse, zPathModulesPath, zPathModulesResponse, zPlaceLessonsBody, zPlaceLessonsPath, zPlaceLessonsResponse, zPlaceModulesBody, zPlaceModulesPath, zPlaceModulesResponse, zPlaceScenesBody, zPlaceScenesPath, zPlaceScenesResponse, zPlanOnboardingBody, zPlanOnboardingResponse, zPostConsultantMessageBody, zPostConsultantMessagePath, zPostConsultantMessageResponse, zPostTrainTurnBody, zPostTrainTurnPath, zPostTrainTurnResponse, zPreflightCurriculumBuildBody, zPreflightCurriculumBuildResponse, zPrepareTrainBriefBody, zPrepareTrainBriefResponse, zPreviewCurriculumDatasetDeletionResponse, zPreviewCurriculumImportBody, zPreviewCurriculumImportResponse, zPreviewPlannedCourseDeletionPath, zPreviewPlannedCourseDeletionResponse, zPreviewPlannedLessonDeletionPath, zPreviewPlannedLessonDeletionResponse, zPreviewPlannedModuleDeletionPath, zPreviewPlannedModuleDeletionResponse, zProposeTrainTwistPath, zProposeTrainTwistResponse, zPublishCollectionBody, zPublishCollectionPath, zPublishCollectionResponse, zPublishOnboardingConfigResponse, zQaAuditResponse, zQueryLessonsBody, zQueryLessonsResponse, zReachSceneBody, zReachScenePath, zReachSceneResponse, zRebuildPlannedLessonBody, zRebuildPlannedLessonPath, zRebuildPlannedLessonResponse, zRegenerateBody, zRegenerateResponse, zRelabelLessonsBody, zRelabelLessonsResponse, zReportFramesBody, zReportFramesResponse, zReportOnboardingEventBody, zReportSceneBody, zReportScenePath, zReportSceneResponse, zRequestLessonFixBody, zRequestLessonFixPath, zRequestLessonFixResponse, zRequestRecastBody, zRequestRecastPath, zRequestRecastResponse, zRequestVisualFixBody, zRequestVisualFixPath, zRequestVisualFixResponse, zRerollObjectPath, zRerollObjectResponse, zRestoreOnboardingConfigBody, zRestoreOnboardingConfigResponse, zRestorePlannedLessonVersionPath, zRestorePlannedLessonVersionResponse, zRetryGenerationPath, zRetryGenerationResponse, zRetryGenerationRowPath, zRetryGenerationRowResponse, zRetryPlannedLessonBuildPath, zRetryPlannedLessonBuildResponse, zRetryTrainSessionBody, zRetryTrainSessionPath, zRetryTrainSessionResponse, zRevertFindingPath, zRevertFindingResponse, zRevertLessonFixPath, zRevertLessonFixResponse, zRevertPlanningRevisionPath, zRevertPlanningRevisionResponse, zRevertVisualFixPath, zRevertVisualFixResponse, zReviewLessonAgainPath, zReviewLessonAgainResponse, zReviewLessonPath, zReviewLessonResponse, zReviewPlannedLessonStoryBody, zReviewPlannedLessonStoryPath, zReviewPlannedLessonStoryResponse, zSaveMyOnboardingBody, zSaveMyOnboardingResponse, zSaveOnboardingConfigDraftBody, zSaveOnboardingConfigDraftResponse, zSaveScenePath, zSaveSceneResponse, zSaveTermPath, zSaveTermResponse, zSaveTrainTakeawayBody, zSaveTrainTakeawayPath, zSaveTrainTakeawayResponse, zSearchEvidenceBody, zSearchEvidenceResponse, zSetLessonReviewBody, zSetLessonReviewPath, zSetLessonReviewResponse, zSetMyStreakGoalBody, zSetMyStreakGoalQuery, zSetMyStreakGoalResponse, zShareAttemptPath, zShareAttemptResponse, zSharedScoreImagePath, zSharedScoreImageResponse, zSharedScorePath, zSharedScoreResponse, zSharePathPath, zSharePathResponse, zSpeakTrainLinePath, zSpeakTrainLineResponse, zStartAttemptPath, zStartAttemptResponse, zStartConsultantThreadBody, zStartConsultantThreadResponse, zStartGenerationBody, zStartGenerationResponse, zStartTrainSessionBody, zStartTrainSessionResponse, zStartVerificationBody, zStartVerificationResponse, zSubmitLessonFeedbackBody, zSubmitLessonFeedbackPath, zSubmitLessonFeedbackResponse, zSuggestTrainSetupBody, zSuggestTrainSetupResponse, zSwitchMechanicBody, zSwitchMechanicPath, zSwitchMechanicResponse, zSwitchMyStreakGoalBody, zSwitchMyStreakGoalQuery, zSwitchMyStreakGoalResponse, zTranscribeConsultantClipBody, zTranscribeConsultantClipResponse, zTranscribeTrainClipBody, zTranscribeTrainClipPath, zTranscribeTrainClipResponse, zUpdateCollectionBody, zUpdateCollectionPath, zUpdateCollectionResponse, zUpdateLessonBody, zUpdateLessonNotesBody, zUpdateLessonNotesPath, zUpdateLessonNotesResponse, zUpdateLessonPath, zUpdateLessonRenameBody, zUpdateLessonRenamePath, zUpdateLessonRenameResponse, zUpdateLessonResponse, zUpdateLessonSourceNoteBody, zUpdateLessonSourceNotePath, zUpdateLessonSourceNoteResponse, zUpdateModuleRenameBody, zUpdateModuleRenamePath, zUpdateModuleRenameResponse, zUpdatePlannedCourseBody, zUpdatePlannedCoursePath, zUpdatePlannedCourseResponse, zUpdatePlannedLessonBody, zUpdatePlannedLessonPath, zUpdatePlannedLessonResponse, zUpdatePlannedModuleBody, zUpdatePlannedModulePath, zUpdatePlannedModuleResponse, zUpdatePlanToMatchAppPath, zUpdatePlanToMatchAppResponse, zUpdateQuestionBody, zUpdateQuestionPath, zUpdateQuestionResponse, zUpdateSceneBody, zUpdateScenePath, zUpdateSceneResponse, zUpsertCollectionBody, zUpsertCollectionResponse, zUpsertLessonBody, zUpsertLessonResponse, zVerifyPlannedLessonsBody, zVerifyPlannedLessonsResponse } from './zod.gen';
/**
 * Liveness. No I/O.
 */
export const getHealth = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetHealthResponse.parseAsync(data),
    url: '/health',
    ...options
});
/**
 * Readiness. Checks dependencies; 503 when degraded.
 */
export const getReadiness = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetReadinessResponse.parseAsync(data),
    url: '/health/ready',
    ...options
});
/**
 * Every generation job, newest first.
 */
export const listGenerations = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListGenerationsResponse.parseAsync(data),
    url: '/authoring/generations',
    ...options
});
/**
 * Queue a parsed CSV as a generation job.
 */
export const startGeneration = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zStartGenerationBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartGenerationResponse.parseAsync(data),
    url: '/authoring/generations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Which of these course and module slugs already exist.
 */
export const findExistingCollections = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zFindExistingCollectionsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFindExistingCollectionsResponse.parseAsync(data),
    url: '/authoring/generations/existing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Write one part of a lesson again, with an instruction.
 */
export const regenerate = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRegenerateBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRegenerateResponse.parseAsync(data),
    url: '/authoring/generations/rewrites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * One job and the state of every row in it.
 */
export const getGeneration = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetGenerationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetGenerationResponse.parseAsync(data),
    url: '/authoring/generations/{id}',
    ...options
});
/**
 * Stop an import, keeping the lessons it has already written.
 */
export const cancelGeneration = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCancelGenerationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCancelGenerationResponse.parseAsync(data),
    url: '/authoring/generations/{id}/cancel',
    ...options
});
/**
 * Put every failed lesson of this import back on the queue.
 */
export const retryGeneration = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryGenerationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryGenerationResponse.parseAsync(data),
    url: '/authoring/generations/{id}/retry',
    ...options
});
/**
 * Generate this one lesson again.
 */
export const retryGenerationRow = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryGenerationRowPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryGenerationRowResponse.parseAsync(data),
    url: '/authoring/generations/rows/{id}/retry',
    ...options
});
/**
 * Put back what this row’s rewrite replaced.
 */
export const discardRewrite = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDiscardRewritePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDiscardRewriteResponse.parseAsync(data),
    url: '/authoring/generations/rows/{id}/discard',
    ...options
});
/**
 * Ask the editor to rewrite the scene this finding names.
 */
export const applyFinding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyFindingPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyFindingResponse.parseAsync(data),
    url: '/authoring/generations/findings/{id}/apply',
    ...options
});
/**
 * Apply the edit the editor proposed for this finding.
 */
export const keepFinding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zKeepFindingPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zKeepFindingResponse.parseAsync(data),
    url: '/authoring/generations/findings/{id}/keep',
    ...options
});
/**
 * Turn down the edit the editor proposed for this finding.
 */
export const discardFinding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDiscardFindingPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDiscardFindingResponse.parseAsync(data),
    url: '/authoring/generations/findings/{id}/discard',
    ...options
});
/**
 * Allow this finding without a fix.
 */
export const dismissFinding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDismissFindingPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDismissFindingResponse.parseAsync(data),
    url: '/authoring/generations/findings/{id}/dismiss',
    ...options
});
/**
 * Put back what the editor replaced when it applied this finding.
 */
export const revertFinding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRevertFindingPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRevertFindingResponse.parseAsync(data),
    url: '/authoring/generations/findings/{id}/revert',
    ...options
});
/**
 * One row per lesson build, newest first.
 */
export const listGenerationLedger = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListGenerationLedgerQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListGenerationLedgerResponse.parseAsync(data),
    url: '/authoring/generation-ledger',
    ...options
});
/**
 * What recurs across recent builds, each with a proposal for the owner to judge.
 */
export const getGenerationPatterns = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetGenerationPatternsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetGenerationPatternsResponse.parseAsync(data),
    url: '/authoring/generation-ledger/patterns',
    ...options
});
/**
 * Ask the planner a question. Nothing is written, and nothing is kept.
 */
export const askPlanner = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAskPlannerBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAskPlannerResponse.parseAsync(data),
    url: '/authoring/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Fill in a draft course so it can publish: its topic, level and card illustration from its modules, and its title and summary written with AI.
 */
export const fillCourse = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zFillCoursePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFillCourseResponse.parseAsync(data),
    url: '/authoring/collections/{id}/fill',
    ...options
});
/**
 * Rewrite one field of a scene with AI so it meets the rules it breaks, and save it.
 */
export const fixSceneField = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zFixSceneFieldBody,
        path: zFixSceneFieldPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFixSceneFieldResponse.parseAsync(data),
    url: '/authoring/scenes/{id}/fixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Queue a verify job: one run per lesson.
 */
export const startVerification = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zStartVerificationBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartVerificationResponse.parseAsync(data),
    url: '/authoring/verifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A lesson’s verification runs, and whether it is Verified.
 */
export const listLessonVerifications = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonVerificationsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonVerificationsResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/verifications',
    ...options
});
/**
 * Every source a lesson cites, with the evidence its last check found.
 */
export const listLessonSourceChecks = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonSourceChecksPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonSourceChecksResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/source-checks',
    ...options
});
/**
 * Find / verify source: check one source, one claim, or both, and propose fixes.
 */
export const checkLessonSources = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCheckLessonSourcesBody,
        path: zCheckLessonSourcesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCheckLessonSourcesResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/source-checks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The runs a job filed, and the guidance they applied.
 */
export const listJobVerifications = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListJobVerificationsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListJobVerificationsResponse.parseAsync(data),
    url: '/authoring/jobs/{id}/verifications',
    ...options
});
/**
 * One verification run: what it checked and found.
 */
export const getVerification = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetVerificationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetVerificationResponse.parseAsync(data),
    url: '/authoring/verifications/{id}',
    ...options
});
/**
 * Every fix asked for on a lesson, and where each stands.
 */
export const listLessonFixes = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonFixesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonFixesResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/fixes',
    ...options
});
/**
 * Ask the editor for a fix to one finding or one unsupported source claim.
 */
export const requestLessonFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRequestLessonFixBody,
        path: zRequestLessonFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRequestLessonFixResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/fixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Write a proposed fix to the working copy and run its checks again.
 */
export const applyLessonFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyLessonFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyLessonFixResponse.parseAsync(data),
    url: '/authoring/fixes/{id}/apply',
    ...options
});
/**
 * Restore the lesson exactly as it was before the fix was applied.
 */
export const revertLessonFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRevertLessonFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRevertLessonFixResponse.parseAsync(data),
    url: '/authoring/fixes/{id}/revert',
    ...options
});
/**
 * Turn down a proposed fix. Nothing was written.
 */
export const discardLessonFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDiscardLessonFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDiscardLessonFixResponse.parseAsync(data),
    url: '/authoring/fixes/{id}/discard',
    ...options
});
/**
 * Every review of a lesson with the version it read, and whether the newest is out of date.
 */
export const listLessonReviews = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonReviewsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonReviewsResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/reviews',
    ...options
});
/**
 * Review the lesson as it is saved now. Nothing is repaired or rewritten.
 */
export const reviewLessonAgain = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zReviewLessonAgainPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReviewLessonAgainResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/reviews',
    ...options
});
/**
 * The full system text behind one of a job’s skill digests.
 */
export const getGenerationPrompt = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetGenerationPromptPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetGenerationPromptResponse.parseAsync(data),
    url: '/authoring/prompts/{digest}',
    ...options
});
/**
 * Every agent’s current system prompt, each distinct text once.
 */
export const listSystemPrompts = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListSystemPromptsResponse.parseAsync(data),
    url: '/authoring/system-prompts',
    ...options
});
/**
 * Every visual fix asked for on a lesson’s scenes.
 */
export const listVisualFixes = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListVisualFixesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListVisualFixesResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/visual-fixes',
    ...options
});
/**
 * Ask AI to change one scene’s characters and props. Nothing is written until Apply.
 */
export const requestVisualFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRequestVisualFixBody,
        path: zRequestVisualFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRequestVisualFixResponse.parseAsync(data),
    url: '/authoring/scenes/{id}/visual-fixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Write a proposed visual fix to its scene.
 */
export const applyVisualFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyVisualFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyVisualFixResponse.parseAsync(data),
    url: '/authoring/visual-fixes/{id}/apply',
    ...options
});
/**
 * Cancel a proposed visual fix. Nothing was written.
 */
export const discardVisualFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDiscardVisualFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDiscardVisualFixResponse.parseAsync(data),
    url: '/authoring/visual-fixes/{id}/discard',
    ...options
});
/**
 * Put back the fields of the scene’s visual the fix changed, leaving every other edit.
 */
export const revertVisualFix = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRevertVisualFixPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRevertVisualFixResponse.parseAsync(data),
    url: '/authoring/visual-fixes/{id}/revert',
    ...options
});
/**
 * Published courses, modules and paths, newest first.
 */
export const listCollections = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListCollectionsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListCollectionsResponse.parseAsync(data),
    url: '/collections',
    ...options
});
/**
 * One collection, with its modules and lessons in order.
 */
export const getCollection = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCollectionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCollectionResponse.parseAsync(data),
    url: '/collections/{slug}',
    ...options
});
/**
 * Every topic a learner can pick, in onboarding’s groups and order.
 */
export const listTopics = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListTopicsResponse.parseAsync(data),
    url: '/topics',
    ...options
});
/**
 * Published lessons, newest first.
 */
export const listLessons = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListLessonsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonsResponse.parseAsync(data),
    url: '/lessons',
    ...options
});
/**
 * Published lessons matching a filter, sent as a body.
 */
export const queryLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zQueryLessonsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQueryLessonsResponse.parseAsync(data),
    url: '/lessons/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A lesson with every scene, in placement order. Never with a key.
 */
export const getLesson = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetLessonResponse.parseAsync(data),
    url: '/lessons/{slug}',
    ...options
});
/**
 * What needs an admin decision, in one prioritized queue.
 */
export const attention = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zAttentionQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAttentionResponse.parseAsync(data),
    url: '/authoring/attention',
    ...options
});
/**
 * Published lessons with scenes QA flagged, grouped by lesson.
 */
export const qaAudit = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zQaAuditResponse.parseAsync(data),
    url: '/authoring/qa-audit',
    ...options
});
/**
 * Every collection the console has, filtered. Drafts included.
 */
export const browseCollections = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zBrowseCollectionsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zBrowseCollectionsResponse.parseAsync(data),
    url: '/authoring/collections',
    ...options
});
/**
 * Create a DRAFT course, module or path.
 */
export const createCollection = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreateCollectionBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateCollectionResponse.parseAsync(data),
    url: '/authoring/collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create or update a collection by slug. Never duplicates.
 */
export const upsertCollection = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zUpsertCollectionBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpsertCollectionResponse.parseAsync(data),
    url: '/authoring/collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * One collection, as its detail screen edits it. Drafts included.
 */
export const getAuthoringCollection = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetAuthoringCollectionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAuthoringCollectionResponse.parseAsync(data),
    url: '/authoring/collections/{id}',
    ...options
});
/**
 * Edit a collection, or move it between DRAFT and PUBLISHED.
 */
export const updateCollection = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateCollectionBody,
        path: zUpdateCollectionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateCollectionResponse.parseAsync(data),
    url: '/authoring/collections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Every lesson the console has, filtered. Drafts included.
 */
export const browseLessons = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zBrowseLessonsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zBrowseLessonsResponse.parseAsync(data),
    url: '/authoring/lessons',
    ...options
});
/**
 * Create a DRAFT lesson. Scenes are placed separately.
 */
export const createLesson = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreateLessonBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateLessonResponse.parseAsync(data),
    url: '/authoring/lessons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create or update a lesson by slug. Never duplicates.
 */
export const upsertLesson = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zUpsertLessonBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpsertLessonResponse.parseAsync(data),
    url: '/authoring/lessons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The tag vocabulary, so a writer can reuse before it invents.
 */
export const listTags = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListTagsResponse.parseAsync(data),
    url: '/authoring/tags',
    ...options
});
/**
 * Take several lessons out of circulation in one statement.
 */
export const archiveLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zArchiveLessonsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zArchiveLessonsResponse.parseAsync(data),
    url: '/authoring/lessons/archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Set the level or the personas on several lessons at once.
 */
export const relabelLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRelabelLessonsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRelabelLessonsResponse.parseAsync(data),
    url: '/authoring/lessons/labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The lessons a collection holds, drafts included.
 */
export const collectionLessons = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCollectionLessonsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCollectionLessonsResponse.parseAsync(data),
    url: '/authoring/collections/{id}/lessons',
    ...options
});
/**
 * Add lessons to what a collection already holds.
 */
export const appendLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAppendLessonsBody,
        path: zAppendLessonsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAppendLessonsResponse.parseAsync(data),
    url: '/authoring/collections/{id}/lessons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Replace which lessons a collection holds, and their order.
 */
export const placeLessons = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zPlaceLessonsBody,
        path: zPlaceLessonsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPlaceLessonsResponse.parseAsync(data),
    url: '/authoring/collections/{id}/lessons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The modules a path holds, each with its lessons, drafts included.
 */
export const pathModules = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zPathModulesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPathModulesResponse.parseAsync(data),
    url: '/authoring/collections/{id}/modules',
    ...options
});
/**
 * Add modules to the end of a path.
 */
export const appendModules = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAppendModulesBody,
        path: zAppendModulesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAppendModulesResponse.parseAsync(data),
    url: '/authoring/collections/{id}/modules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Replace which modules a path holds, and their order.
 */
export const placeModules = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zPlaceModulesBody,
        path: zPlaceModulesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPlaceModulesResponse.parseAsync(data),
    url: '/authoring/collections/{id}/modules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What stops a collection and everything under it publishing, and which approved drafts it takes live.
 */
export const collectionPublishReadiness = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCollectionPublishReadinessPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCollectionPublishReadinessResponse.parseAsync(data),
    url: '/authoring/collections/{id}/publish-readiness',
    ...options
});
/**
 * Publish a collection and every approved draft under it, together or not at all.
 */
export const publishCollection = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPublishCollectionBody,
        path: zPublishCollectionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPublishCollectionResponse.parseAsync(data),
    url: '/authoring/collections/{id}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What learners said of a lesson, per published version, and who said it where they have written to support.
 */
export const lessonFeedback = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zLessonFeedbackPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLessonFeedbackResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/feedback',
    ...options
});
/**
 * Edit a lesson, or move it between DRAFT and PUBLISHED.
 */
export const updateLesson = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateLessonBody,
        path: zUpdateLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateLessonResponse.parseAsync(data),
    url: '/authoring/lessons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Replace a lesson’s scene order wholesale.
 */
export const placeScenes = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zPlaceScenesBody,
        path: zPlaceScenesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPlaceScenesResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/scenes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A draft lesson with its answer keys, for a reviewer.
 */
export const reviewLesson = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zReviewLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReviewLessonResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/review',
    ...options
});
/**
 * Approve, ask for changes, mark for review by hand, or clear the status.
 */
export const setLessonReview = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSetLessonReviewBody,
        path: zSetLessonReviewPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSetLessonReviewResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Re-pick the illustration object from what the lesson’s scenes do.
 */
export const rerollObject = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRerollObjectPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRerollObjectResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/object',
    ...options
});
/**
 * What stops a lesson publishing. Empty means it would.
 */
export const lessonPublishReadiness = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zLessonPublishReadinessPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLessonPublishReadinessResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/publish-readiness',
    ...options
});
/**
 * Create a DRAFT question, reusable by any scene.
 */
export const createQuestion = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreateQuestionBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateQuestionResponse.parseAsync(data),
    url: '/authoring/questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Edit a question, or move it between DRAFT and PUBLISHED.
 */
export const updateQuestion = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateQuestionBody,
        path: zUpdateQuestionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateQuestionResponse.parseAsync(data),
    url: '/authoring/questions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record what a lesson or scene was grounded in.
 */
export const createSource = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreateSourceBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateSourceResponse.parseAsync(data),
    url: '/authoring/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create a scene with its items and buckets in one write.
 */
export const createScene = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreateSceneBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreateSceneResponse.parseAsync(data),
    url: '/authoring/scenes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Correct a scene’s text by hand. Structure is not editable here.
 */
export const updateScene = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateSceneBody,
        path: zUpdateScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateSceneResponse.parseAsync(data),
    url: '/authoring/scenes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Change how an existing question is asked, keeping what it asks.
 */
export const switchMechanic = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSwitchMechanicBody,
        path: zSwitchMechanicPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSwitchMechanicResponse.parseAsync(data),
    url: '/authoring/lessons/{lessonId}/scenes/{sceneId}/mechanic',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What a lesson is based on: its sources, notes and review.
 */
export const lessonResearch = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zLessonResearchPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLessonResearchResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/research',
    ...options
});
/**
 * Cite a shared source in this lesson. Sends the review back to Needs review.
 */
export const attachLessonSource = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAttachLessonSourceBody,
        path: zAttachLessonSourcePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAttachLessonSourceResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Stop citing a source here, with its note. The shared source stays for other lessons.
 */
export const detachLessonSource = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDetachLessonSourcePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDetachLessonSourceResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/sources/{sourceId}',
    ...options
});
/**
 * Change what a source backs in this lesson. Leaves review alone.
 */
export const updateLessonSourceNote = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateLessonSourceNoteBody,
        path: zUpdateLessonSourceNotePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateLessonSourceNoteResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/sources/{sourceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Replace the lesson’s notes. Refused past 150 words.
 */
export const updateLessonNotes = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zUpdateLessonNotesBody,
        path: zUpdateLessonNotesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateLessonNotesResponse.parseAsync(data),
    url: '/authoring/lessons/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Every image version generated for a scene, and a first prompt.
 */
export const listSceneImages = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListSceneImagesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListSceneImagesResponse.parseAsync(data),
    url: '/authoring/scenes/{id}/images',
    ...options
});
/**
 * Draw a new version from a prompt, or refine one with feedback.
 */
export const generateSceneImage = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zGenerateSceneImageBody,
        path: zGenerateSceneImagePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGenerateSceneImageResponse.parseAsync(data),
    url: '/authoring/scenes/{id}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Put a version on its scene; a published lesson shows it after its next publish.
 */
export const approveSceneImage = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApproveSceneImagePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApproveSceneImageResponse.parseAsync(data),
    url: '/authoring/scene-images/{id}/approve',
    ...options
});
/**
 * Attach a catalog image to a scene, or take its image off.
 */
export const chooseSceneImage = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zChooseSceneImageBody,
        path: zChooseSceneImagePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zChooseSceneImageResponse.parseAsync(data),
    url: '/authoring/scenes/{id}/image',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * An approved scene image, as SVG.
 */
export const getSceneImageFile = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetSceneImageFilePath,
        query: zGetSceneImageFileQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetSceneImageFileResponse.parseAsync(data),
    url: '/scene-images/{file}',
    ...options
});
/**
 * Draw a candidate visual for an onboarding screen, or refine one.
 */
export const drawOnboardingArt = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zDrawOnboardingArtBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDrawOnboardingArtResponse.parseAsync(data),
    url: '/authoring/onboarding/art',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The newest cover drawn for a lesson.
 */
export const getLessonCover = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetLessonCoverPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetLessonCoverResponse.parseAsync(data),
    url: '/pictures/covers/{slug}',
    ...options
});
/**
 * A drawn scene picture.
 */
export const getPicture = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetPicturePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPictureResponse.parseAsync(data),
    url: '/pictures/{id}',
    ...options
});
/**
 * Every character with what it may do on screen, and every scene prop added.
 */
export const listCast = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListCastResponse.parseAsync(data),
    url: '/cast',
    ...options
});
/**
 * Add a scene prop. It is pending until its art lands.
 */
export const addSceneProp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAddScenePropBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAddScenePropResponse.parseAsync(data),
    url: '/cast/props',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What importing this CSV would add and change, without writing.
 */
export const previewCurriculumImport = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPreviewCurriculumImportBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreviewCurriculumImportResponse.parseAsync(data),
    url: '/curriculum/import/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Apply a CSV to the plan, keyed on Lesson ID, skipping lines with problems.
 */
export const importCurriculum = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zImportCurriculumBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zImportCurriculumResponse.parseAsync(data),
    url: '/curriculum/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The planned lessons, searched, filtered, sorted and paged.
 */
export const listPlannedLessons = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListPlannedLessonsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListPlannedLessonsResponse.parseAsync(data),
    url: '/curriculum/lessons',
    ...options
});
/**
 * Add a planned lesson, last in its module.
 */
export const createPlannedLesson = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreatePlannedLessonBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedLessonResponse.parseAsync(data),
    url: '/curriculum/lessons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The planned lessons as CSV, every planning column.
 */
export const exportPlannedLessons = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zExportPlannedLessonsQuery
    }).parseAsync(data),
    responseValidator: async (data) => await zExportPlannedLessonsResponse.parseAsync(data),
    url: '/curriculum/lessons/export',
    ...options
});
/**
 * Remove a planned lesson. Its Lesson ID is never given to another.
 */
export const deletePlannedLesson = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeletePlannedLessonPath,
        query: zDeletePlannedLessonQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeletePlannedLessonResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}',
    ...options
});
/**
 * One planned lesson: planning, links, build, approval, publications, history and learners.
 */
export const getPlannedLessonDetails = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetPlannedLessonDetailsPath,
        query: zGetPlannedLessonDetailsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPlannedLessonDetailsResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}',
    ...options
});
/**
 * Edit a planned lesson’s fields, move it to another module, or reorder it.
 */
export const updatePlannedLesson = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdatePlannedLessonBody,
        path: zUpdatePlannedLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdatePlannedLessonResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create this planned course in the app, or return the one it links to.
 */
export const createPlannedCourseInApp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCreatePlannedCourseInAppPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedCourseInAppResponse.parseAsync(data),
    url: '/curriculum/courses/{id}/create-in-app',
    ...options
});
/**
 * Create this planned module in the app, and its course if that is not there yet.
 */
export const createPlannedModuleInApp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCreatePlannedModuleInAppPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedModuleInAppResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/create-in-app',
    ...options
});
/**
 * Create the selected planned courses and modules in the app.
 */
export const createPlannedInApp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreatePlannedInAppBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedInAppResponse.parseAsync(data),
    url: '/curriculum/create-in-app',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What building these lessons would do, without doing it.
 */
export const preflightCurriculumBuild = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPreflightCurriculumBuildBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreflightCurriculumBuildResponse.parseAsync(data),
    url: '/curriculum/builds/preflight',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Build up to 50 planned lessons as drafts, in one job.
 */
export const buildPlannedLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zBuildPlannedLessonsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zBuildPlannedLessonsResponse.parseAsync(data),
    url: '/curriculum/builds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Verify the lessons built from these planned rows against their sources, in one job.
 */
export const verifyPlannedLessons = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zVerifyPlannedLessonsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zVerifyPlannedLessonsResponse.parseAsync(data),
    url: '/curriculum/verifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Build a lesson whose build failed again.
 */
export const retryPlannedLessonBuild = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRetryPlannedLessonBuildPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryPlannedLessonBuildResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/retry',
    ...options
});
/**
 * Take a queued lesson out of its build.
 */
export const cancelPlannedLessonBuild = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCancelPlannedLessonBuildPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCancelPlannedLessonBuildResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/cancel',
    ...options
});
/**
 * Rebuild a built draft lesson in place, keeping what it replaces as a version.
 */
export const rebuildPlannedLesson = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRebuildPlannedLessonBody.optional(),
        path: zRebuildPlannedLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRebuildPlannedLessonResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/rebuild',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Mark a built lesson reviewed against its module’s current story, clearing Story changed. Its content is untouched.
 */
export const reviewPlannedLessonStory = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zReviewPlannedLessonStoryBody,
        path: zReviewPlannedLessonStoryPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReviewPlannedLessonStoryResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/story-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What the built lesson held before each rebuild or restore.
 */
export const listPlannedLessonVersions = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListPlannedLessonVersionsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListPlannedLessonVersionsResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/versions',
    ...options
});
/**
 * Put a version back on the built draft lesson; what it replaces becomes a version.
 */
export const restorePlannedLessonVersion = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRestorePlannedLessonVersionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRestorePlannedLessonVersionResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/versions/{versionId}/restore',
    ...options
});
/**
 * Where the built lesson sits in the app against the plan, with both syncs previewed.
 */
export const getPlannedLessonPlacement = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetPlannedLessonPlacementPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPlannedLessonPlacementResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/placement',
    ...options
});
/**
 * Move the planned lesson to the module the app has it in.
 */
export const updatePlanToMatchApp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zUpdatePlanToMatchAppPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdatePlanToMatchAppResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/placement/update-plan',
    ...options
});
/**
 * Move the app lesson to the module the plan has it in.
 */
export const moveAppLessonToMatchPlan = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zMoveAppLessonToMatchPlanPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMoveAppLessonToMatchPlanResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/placement/move-app-lesson',
    ...options
});
/**
 * The planned courses and their modules, in curriculum order.
 */
export const listPlannedCourses = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListPlannedCoursesResponse.parseAsync(data),
    url: '/curriculum/courses',
    ...options
});
/**
 * Add a planned course, last.
 */
export const createPlannedCourse = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreatePlannedCourseBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedCourseResponse.parseAsync(data),
    url: '/curriculum/courses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove a planned course, its modules and lessons.
 */
export const deletePlannedCourse = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeletePlannedCoursePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeletePlannedCourseResponse.parseAsync(data),
    url: '/curriculum/courses/{id}',
    ...options
});
/**
 * Rename or reorder a planned course.
 */
export const updatePlannedCourse = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdatePlannedCourseBody,
        path: zUpdatePlannedCoursePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdatePlannedCourseResponse.parseAsync(data),
    url: '/curriculum/courses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What removing a planned course would remove.
 */
export const previewPlannedCourseDeletion = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zPreviewPlannedCourseDeletionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreviewPlannedCourseDeletionResponse.parseAsync(data),
    url: '/curriculum/courses/{id}/deletion-preview',
    ...options
});
/**
 * Add a planned module, last in its course.
 */
export const createPlannedModule = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCreatePlannedModuleBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCreatePlannedModuleResponse.parseAsync(data),
    url: '/curriculum/modules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove a planned module and its lessons.
 */
export const deletePlannedModule = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeletePlannedModulePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeletePlannedModuleResponse.parseAsync(data),
    url: '/curriculum/modules/{id}',
    ...options
});
/**
 * Rename, move to another course, reorder, or save the story and cast of a planned module.
 */
export const updatePlannedModule = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdatePlannedModuleBody,
        path: zUpdatePlannedModulePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdatePlannedModuleResponse.parseAsync(data),
    url: '/curriculum/modules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A planned module’s story, its cast and each lesson’s subset, and the revision to save them against.
 */
export const getPlannedModuleStory = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetPlannedModuleStoryPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetPlannedModuleStoryResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/story',
    ...options
});
/**
 * The Lesson ID a lesson added to this module would be given.
 */
export const nextPlannedLessonId = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zNextPlannedLessonIdPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zNextPlannedLessonIdResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/next-lesson-id',
    ...options
});
/**
 * What removing a planned module would remove.
 */
export const previewPlannedModuleDeletion = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zPreviewPlannedModuleDeletionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreviewPlannedModuleDeletionResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/deletion-preview',
    ...options
});
/**
 * Apply the chat’s planning proposals, one or all. Each lands as a revision; a stale or missing one is refused and the rest still apply.
 */
export const applyPlanningProposals = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zApplyPlanningProposalsBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyPlanningProposalsResponse.parseAsync(data),
    url: '/curriculum/proposals/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Accept the chat’s module story and its beats, as one story revision.
 */
export const applyStoryProposal = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zApplyStoryProposalBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyStoryProposalResponse.parseAsync(data),
    url: '/curriculum/proposals/apply-story',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * What removing a planned lesson would remove.
 */
export const previewPlannedLessonDeletion = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zPreviewPlannedLessonDeletionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreviewPlannedLessonDeletionResponse.parseAsync(data),
    url: '/curriculum/lessons/{lessonId}/deletion-preview',
    ...options
});
/**
 * What deleting the whole imported plan would remove.
 */
export const previewCurriculumDatasetDeletion = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPreviewCurriculumDatasetDeletionResponse.parseAsync(data),
    url: '/curriculum/dataset/deletion-preview',
    ...options
});
/**
 * Delete the whole plan. App content and the application stay.
 */
export const deleteCurriculumDataset = (options) => (options?.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteCurriculumDatasetResponse.parseAsync(data),
    url: '/curriculum/dataset',
    ...options
});
/**
 * Planning edit history: who changed what, and when.
 */
export const listPlanningRevisions = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListPlanningRevisionsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListPlanningRevisionsResponse.parseAsync(data),
    url: '/curriculum/revisions',
    ...options
});
/**
 * Put a planned row back as it was before this revision.
 */
export const revertPlanningRevision = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRevertPlanningRevisionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRevertPlanningRevisionResponse.parseAsync(data),
    url: '/curriculum/revisions/{id}/revert',
    ...options
});
/**
 * Proposed names for modules whose name repeats across courses.
 */
export const listModuleRenames = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListModuleRenamesResponse.parseAsync(data),
    url: '/curriculum/module-renames',
    ...options
});
/**
 * Change one proposed module name, skip it, or choose to rename its app module too.
 */
export const updateModuleRename = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateModuleRenameBody,
        path: zUpdateModuleRenamePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateModuleRenameResponse.parseAsync(data),
    url: '/curriculum/module-renames/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Approve every module rename not skipped. IDs, lessons, order and links stay.
 */
export const applyModuleRenames = (options) => (options?.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyModuleRenamesResponse.parseAsync(data),
    url: '/curriculum/module-renames/apply',
    ...options
});
/**
 * Approve one module rename. Every other module stays as it is.
 */
export const applyModuleRename = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyModuleRenamePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyModuleRenameResponse.parseAsync(data),
    url: '/curriculum/module-renames/{id}/apply',
    ...options
});
/**
 * Proposed titles for lessons whose title repeats in the plan.
 */
export const listLessonRenames = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonRenamesResponse.parseAsync(data),
    url: '/curriculum/lesson-renames',
    ...options
});
/**
 * Change one proposed lesson title, skip it, or choose to rename its app lesson too.
 */
export const updateLessonRename = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zUpdateLessonRenameBody,
        path: zUpdateLessonRenamePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zUpdateLessonRenameResponse.parseAsync(data),
    url: '/curriculum/lesson-renames/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Approve every lesson title not skipped. IDs, order, sources and links stay.
 */
export const applyLessonRenames = (options) => (options?.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyLessonRenamesResponse.parseAsync(data),
    url: '/curriculum/lesson-renames/apply',
    ...options
});
/**
 * Approve one lesson title. Every other lesson stays as it is.
 */
export const applyLessonRename = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyLessonRenamePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyLessonRenameResponse.parseAsync(data),
    url: '/curriculum/lesson-renames/{id}/apply',
    ...options
});
/**
 * Ask about planned lessons in one scope. Nothing is written, and nothing is kept.
 */
export const askCurriculum = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAskCurriculumBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAskCurriculumResponse.parseAsync(data),
    url: '/curriculum/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * How many planned lessons a scope holds, in which courses and modules, before anything is asked.
 */
export const describePlanningScope = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zDescribePlanningScopeBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDescribePlanningScopeResponse.parseAsync(data),
    url: '/curriculum/chat/scope',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Fix with AI at module scope: a replacement proposes a recast, anything else drafts the story, figures and beats. Nothing is written until it is applied.
 */
export const fixModule = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zFixModuleBody,
        path: zFixModulePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFixModuleResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/fixes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Propose replacing one of the module’s cast in every built lesson. Nothing is written until Apply.
 */
export const requestRecast = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRequestRecastBody,
        path: zRequestRecastPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRequestRecastResponse.parseAsync(data),
    url: '/curriculum/modules/{id}/recasts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Write a proposed recast to the drafts, swap the assignment and bump the module revision.
 */
export const applyRecast = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zApplyRecastPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zApplyRecastResponse.parseAsync(data),
    url: '/curriculum/recasts/{id}/apply',
    ...options
});
/**
 * Cancel a proposed recast. Nothing was written.
 */
export const discardRecast = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDiscardRecastPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDiscardRecastResponse.parseAsync(data),
    url: '/curriculum/recasts/{id}/discard',
    ...options
});
/**
 * The authenticated caller. Creates the account row on first call.
 */
export const getMe = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMeResponse.parseAsync(data),
    url: '/me',
    ...options
});
/**
 * The learner’s journey, their next lesson, and their streak and XP.
 */
export const getHome = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetHomeQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetHomeResponse.parseAsync(data),
    url: '/home',
    ...options
});
/**
 * Every badge, earned and locked, with the learner’s streak and XP.
 */
export const getBadges = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetBadgesQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetBadgesResponse.parseAsync(data),
    url: '/me/badges',
    ...options
});
/**
 * Drop the running goal. The streak and its freezes are kept.
 */
export const dropMyStreakGoal = (options) => (options?.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zDropMyStreakGoalQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDropMyStreakGoalResponse.parseAsync(data),
    url: '/me/streak-goal',
    ...options
});
/**
 * The learner’s streak goal, freezes and what Home has not shown yet.
 */
export const getMyStreakGoal = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetMyStreakGoalQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMyStreakGoalResponse.parseAsync(data),
    url: '/me/streak-goal',
    ...options
});
/**
 * Switch the running goal to another one longer than its progress, keeping that progress.
 */
export const switchMyStreakGoal = (options) => (options.client ?? client).patch({
    requestValidator: async (data) => await z.object({
        body: zSwitchMyStreakGoalBody,
        path: z.never().optional(),
        query: zSwitchMyStreakGoalQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSwitchMyStreakGoalResponse.parseAsync(data),
    url: '/me/streak-goal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Start a streak goal. Progress counts from today, today included.
 */
export const setMyStreakGoal = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zSetMyStreakGoalBody,
        path: z.never().optional(),
        query: zSetMyStreakGoalQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSetMyStreakGoalResponse.parseAsync(data),
    url: '/me/streak-goal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Acknowledge events Home has shown, so each shows once.
 */
export const markMyStreakEventsSeen = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zMarkMyStreakEventsSeenBody,
        path: z.never().optional(),
        query: zMarkMyStreakEventsSeenQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMarkMyStreakEventsSeenResponse.parseAsync(data),
    url: '/me/streak-goal/events/seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Paths and courses, each with how far this learner has got.
 */
export const getExplore = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetExploreQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetExploreResponse.parseAsync(data),
    url: '/explore',
    ...options
});
/**
 * How far this learner has got through one collection.
 */
export const getCollectionProgress = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCollectionProgressPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCollectionProgressResponse.parseAsync(data),
    url: '/collections/{slug}/progress',
    ...options
});
/**
 * Every topic with whether it can be started, and goal suggestions.
 */
export const getOnboardingOptions = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOnboardingOptionsResponse.parseAsync(data),
    url: '/onboarding/options',
    ...options
});
/**
 * A guest’s answers, with the starting topic and path they produce.
 */
export const planOnboarding = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPlanOnboardingBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPlanOnboardingResponse.parseAsync(data),
    url: '/onboarding/path',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Grade a guest’s answer to one question of the built-in first challenge.
 */
export const gradeFirstChallenge = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zGradeFirstChallengeBody,
        path: zGradeFirstChallengePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGradeFirstChallengeResponse.parseAsync(data),
    url: '/onboarding/challenges/{slug}/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A guest starting, leaving or finishing the first challenge.
 */
export const reportOnboardingEvent = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zReportOnboardingEventBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    url: '/onboarding/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The learner’s saved answers and the path they produce.
 */
export const getMyOnboarding = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetMyOnboardingResponse.parseAsync(data),
    url: '/me/onboarding',
    ...options
});
/**
 * Replace the learner’s answers — a guest’s answers on sign-up or sign-in, or an edit.
 */
export const saveMyOnboarding = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSaveMyOnboardingBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveMyOnboardingResponse.parseAsync(data),
    url: '/me/onboarding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Every onboarding string a config can reword, with its English.
 */
export const getOnboardingCopyCatalog = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetOnboardingCopyCatalogResponse.parseAsync(data),
    url: '/authoring/onboarding/copy',
    ...options
});
/**
 * Every onboarding config version, and which one is live.
 */
export const listOnboardingConfigs = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListOnboardingConfigsResponse.parseAsync(data),
    url: '/authoring/onboarding/config',
    ...options
});
/**
 * Write the draft, creating it if there is none.
 */
export const saveOnboardingConfigDraft = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSaveOnboardingConfigDraftBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveOnboardingConfigDraftResponse.parseAsync(data),
    url: '/authoring/onboarding/config/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Make the draft the live config.
 */
export const publishOnboardingConfig = (options) => (options?.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPublishOnboardingConfigResponse.parseAsync(data),
    url: '/authoring/onboarding/config/draft/publish',
    ...options
});
/**
 * Roll back: publish a copy of an earlier version.
 */
export const restoreOnboardingConfig = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRestoreOnboardingConfigBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRestoreOnboardingConfigResponse.parseAsync(data),
    url: '/authoring/onboarding/config/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Begin a lesson. Returns the attempt everything else is posted against.
 */
export const startAttempt = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zStartAttemptPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartAttemptResponse.parseAsync(data),
    url: '/lessons/{slug}/attempts',
    ...options
});
/**
 * Where an unfinished run of this lesson picks up, if it has one.
 */
export const lessonResume = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zLessonResumePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zLessonResumeResponse.parseAsync(data),
    url: '/lessons/{slug}/resume',
    ...options
});
/**
 * The lesson as this attempt started it, every scene in order.
 */
export const attemptLesson = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zAttemptLessonPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAttemptLessonResponse.parseAsync(data),
    url: '/attempts/{id}/lesson',
    ...options
});
/**
 * Submit one scene’s answer. Graded on the server.
 */
export const answerScene = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAnswerSceneBody,
        path: zAnswerScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAnswerSceneResponse.parseAsync(data),
    url: '/attempts/{id}/scenes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record the scene a run has opened, so a reload returns to it. Never moves back.
 */
export const reachScene = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zReachSceneBody,
        path: zReachScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReachSceneResponse.parseAsync(data),
    url: '/attempts/{id}/position',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Finish a lesson and record the learner’s local date.
 */
export const completeAttempt = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zCompleteAttemptBody,
        path: zCompleteAttemptPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zCompleteAttemptResponse.parseAsync(data),
    url: '/attempts/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Say whether the lesson was useful. A later answer on the same lesson version replaces this one.
 */
export const submitLessonFeedback = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSubmitLessonFeedbackBody,
        path: zSubmitLessonFeedbackPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSubmitLessonFeedbackResponse.parseAsync(data),
    url: '/attempts/{id}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Stop keeping this scene. Succeeds whether or not it was saved.
 */
export const forgetScene = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zForgetScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zForgetSceneResponse.parseAsync(data),
    url: '/lessons/{slug}/scenes/{sceneId}/bookmark',
    ...options
});
/**
 * Keep this scene. Saving one that is already saved changes nothing.
 */
export const saveScene = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSaveScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveSceneResponse.parseAsync(data),
    url: '/lessons/{slug}/scenes/{sceneId}/bookmark',
    ...options
});
/**
 * Which scenes of this lesson the caller has saved.
 */
export const listLessonBookmarks = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonBookmarksPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonBookmarksResponse.parseAsync(data),
    url: '/lessons/{slug}/bookmarks',
    ...options
});
/**
 * Every scene the caller has saved, most recent first.
 */
export const listSavedScenes = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListSavedScenesQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListSavedScenesResponse.parseAsync(data),
    url: '/me/saved-scenes',
    ...options
});
/**
 * Say what is wrong with this scene.
 */
export const reportScene = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zReportSceneBody,
        path: zReportScenePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReportSceneResponse.parseAsync(data),
    url: '/lessons/{slug}/scenes/{sceneId}/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Stop keeping this term. Succeeds whether or not it was saved.
 */
export const forgetTerm = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zForgetTermPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zForgetTermResponse.parseAsync(data),
    url: '/lessons/{slug}/terms/{term}/saved',
    ...options
});
/**
 * Keep this term. Saving one that is already saved changes nothing.
 */
export const saveTerm = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSaveTermPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveTermResponse.parseAsync(data),
    url: '/lessons/{slug}/terms/{term}/saved',
    ...options
});
/**
 * Which terms of this lesson the caller has saved.
 */
export const listLessonSavedTerms = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListLessonSavedTermsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListLessonSavedTermsResponse.parseAsync(data),
    url: '/lessons/{slug}/saved-terms',
    ...options
});
/**
 * Every term the caller has saved, most recent first.
 */
export const listSavedTerms = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListSavedTermsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListSavedTermsResponse.parseAsync(data),
    url: '/me/saved-terms',
    ...options
});
/**
 * A published lesson, as its share link previews it.
 */
export const getLessonShare = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetLessonSharePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetLessonShareResponse.parseAsync(data),
    url: '/share/lesson/{slug}',
    ...options
});
/**
 * A published path, course or module, as its share link previews it.
 */
export const getCollectionShare = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCollectionSharePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetCollectionShareResponse.parseAsync(data),
    url: '/share/collection/{slug}',
    ...options
});
/**
 * A published short, as its share link previews it.
 */
export const getShortShare = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetShortSharePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetShortShareResponse.parseAsync(data),
    url: '/share/short/{id}',
    ...options
});
/**
 * A shared score, for anyone holding the link. Names the lesson or path, never the learner.
 */
export const sharedScore = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSharedScorePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSharedScoreResponse.parseAsync(data),
    url: '/share/score/{token}',
    ...options
});
/**
 * A shared score drawn on its lesson’s or path’s picture, as a 1200×630 PNG.
 */
export const sharedScoreImage = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSharedScoreImagePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSharedScoreImageResponse.parseAsync(data),
    url: '/share/score/{token}/image',
    ...options
});
/**
 * A link token for this finished lesson’s score. Asking again returns the same token.
 */
export const shareAttempt = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zShareAttemptPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zShareAttemptResponse.parseAsync(data),
    url: '/attempts/{id}/share',
    ...options
});
/**
 * A link token for the caller’s finished path. Asking again returns the same token.
 */
export const sharePath = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSharePathPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSharePathResponse.parseAsync(data),
    url: '/collections/{slug}/share',
    ...options
});
/**
 * One page of the caller’s feed — one idea per short, unseen first, blended across topics.
 */
export const getShorts = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetShortsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetShortsResponse.parseAsync(data),
    url: '/shorts',
    ...options
});
/**
 * Record that the caller read one short. The first read earns one XP, ten a day at most; five in a day extend the streak.
 */
export const markShortSeen = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zMarkShortSeenBody,
        path: zMarkShortSeenPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zMarkShortSeenResponse.parseAsync(data),
    url: '/shorts/{id}/seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Send the team a message. Re-sending with the same request id updates it rather than filing a second.
 */
export const fileSupportRequest = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zFileSupportRequestBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zFileSupportRequestResponse.parseAsync(data),
    url: '/support/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Every role-play on offer, or those on one topic, without its script.
 */
export const listScenarios = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListScenariosQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListScenariosResponse.parseAsync(data),
    url: '/train/scenarios',
    ...options
});
/**
 * One role-play, with every turn and what each reply is worth.
 */
export const getScenario = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetScenarioPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetScenarioResponse.parseAsync(data),
    url: '/train/scenarios/{slug}',
    ...options
});
/**
 * Who the learner can practice a role-play with.
 */
export const listTrainCounterparts = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListTrainCounterpartsResponse.parseAsync(data),
    url: '/train/counterparts',
    ...options
});
/**
 * Ready-made role-plays, each with a prefilled setup to edit.
 */
export const listTrainStarters = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListTrainStartersResponse.parseAsync(data),
    url: '/train/starters',
    ...options
});
/**
 * Suggest a scenario. Fields the learner filled are kept, with alternatives beside them. Spends nothing.
 */
export const suggestTrainSetup = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zSuggestTrainSetupBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSuggestTrainSetupResponse.parseAsync(data),
    url: '/train/setups/suggestion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Prepare the brief to review before practice, or the one question to answer first. Spends nothing; the same key returns the same result.
 */
export const prepareTrainBrief = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPrepareTrainBriefBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPrepareTrainBriefResponse.parseAsync(data),
    url: '/train/setups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The learner’s own role-plays, unfinished and completed.
 */
export const listTrainSessions = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListTrainSessionsResponse.parseAsync(data),
    url: '/train/sessions',
    ...options
});
/**
 * Start a session from a confirmed setup. Spends one custom Train session.
 */
export const startTrainSession = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zStartTrainSessionBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartTrainSessionResponse.parseAsync(data),
    url: '/train/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a role-play: its transcript, its feedback and its takeaway.
 */
export const deleteTrainSession = (options) => (options.client ?? client).delete({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteTrainSessionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteTrainSessionResponse.parseAsync(data),
    url: '/train/sessions/{id}',
    ...options
});
/**
 * One session: its setup, its transcript, and its debrief once ended.
 */
export const getTrainSession = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetTrainSessionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetTrainSessionResponse.parseAsync(data),
    url: '/train/sessions/{id}',
    ...options
});
/**
 * Say something; the counterpart answers in character.
 */
export const postTrainTurn = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPostTrainTurnBody,
        path: zPostTrainTurnPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPostTrainTurnResponse.parseAsync(data),
    url: '/train/sessions/{id}/turns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Ask LEO for a hint or an example reply, for where the conversation is. Spends no reply.
 */
export const askTrainHelp = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAskTrainHelpBody,
        path: zAskTrainHelpPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAskTrainHelpResponse.parseAsync(data),
    url: '/train/sessions/{id}/help',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * End the session and get its debrief. Ending it again returns the same debrief.
 */
export const endTrainSession = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zEndTrainSessionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zEndTrainSessionResponse.parseAsync(data),
    url: '/train/sessions/{id}/end',
    ...options
});
/**
 * Keep a takeaway from the feedback on this session. Saving again replaces it.
 */
export const saveTrainTakeaway = (options) => (options.client ?? client).put({
    requestValidator: async (data) => await z.object({
        body: zSaveTrainTakeawayBody,
        path: zSaveTrainTakeawayPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSaveTrainTakeawayResponse.parseAsync(data),
    url: '/train/sessions/{id}/takeaway',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Propose one changed constraint for a retry, for the learner to confirm. Spends nothing; asking again replaces the proposal.
 */
export const proposeTrainTwist = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zProposeTrainTwistPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposeTrainTwistResponse.parseAsync(data),
    url: '/train/sessions/{id}/twist',
    ...options
});
/**
 * Try a finished role-play again, the same or with a confirmed twist, as a new attempt. The first retry of a session that spent one is free; later retries spend one. The same key starts one attempt.
 */
export const retryTrainSession = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zRetryTrainSessionBody,
        path: zRetryTrainSessionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRetryTrainSessionResponse.parseAsync(data),
    url: '/train/sessions/{id}/retries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Turn a recorded clip into text for the learner to check and send. The clip is not kept.
 */
export const transcribeTrainClip = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zTranscribeTrainClipBody,
        path: zTranscribeTrainClipPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTranscribeTrainClipResponse.parseAsync(data),
    url: '/train/sessions/{id}/transcripts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A counterpart line as audio: 0 is the opening, n the reply to turn n. Generated once, then replayed.
 */
export const speakTrainLine = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zSpeakTrainLinePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSpeakTrainLineResponse.parseAsync(data),
    url: '/train/sessions/{id}/lines/{line}/speech',
    ...options
});
/**
 * How many Consultant submissions and custom Train sessions the caller has left today, and when that resets.
 */
export const getAiAllowance = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetAiAllowanceResponse.parseAsync(data),
    url: '/ai/allowance',
    ...options
});
/**
 * Passages from published lessons that answer a question, each with the source behind it.
 */
export const searchEvidence = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zSearchEvidenceBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zSearchEvidenceResponse.parseAsync(data),
    url: '/evidence/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Questions this scene can answer, worded for where the learner is.
 */
export const askSuggestions = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zAskSuggestionsPath,
        query: zAskSuggestionsQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAskSuggestionsResponse.parseAsync(data),
    url: '/lessons/{slug}/scenes/{sceneId}/ask',
    ...options
});
/**
 * Ask about this scene. Before the learner answers it, the tutor explains and does not hint.
 */
export const askTutor = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zAskTutorBody,
        path: zAskTutorPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zAskTutorResponse.parseAsync(data),
    url: '/lessons/{slug}/scenes/{sceneId}/ask',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The user’s 20 most recent Consultant threads, newest first.
 */
export const listConsultantThreads = (options) => (options?.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zListConsultantThreadsResponse.parseAsync(data),
    url: '/consultant/threads',
    ...options
});
/**
 * Start a thread with the user’s first message. Spends one Consultant submission.
 */
export const startConsultantThread = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zStartConsultantThreadBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zStartConsultantThreadResponse.parseAsync(data),
    url: '/consultant/threads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * One thread, oldest exchange first.
 */
export const getConsultantThread = (options) => (options.client ?? client).get({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetConsultantThreadPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zGetConsultantThreadResponse.parseAsync(data),
    url: '/consultant/threads/{id}',
    ...options
});
/**
 * Continue a thread. The Consultant sees the thread so far. Spends one Consultant submission.
 */
export const postConsultantMessage = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zPostConsultantMessageBody,
        path: zPostConsultantMessagePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zPostConsultantMessageResponse.parseAsync(data),
    url: '/consultant/threads/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Turn a recorded question into text for the user to check and send. The clip is not kept, and no submission is spent.
 */
export const transcribeConsultantClip = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zTranscribeConsultantClipBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zTranscribeConsultantClipResponse.parseAsync(data),
    url: '/consultant/transcripts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Frame-rate samples from a device, recorded as a metric.
 */
export const reportFrames = (options) => (options.client ?? client).post({
    requestValidator: async (data) => await z.object({
        body: zReportFramesBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zReportFramesResponse.parseAsync(data),
    url: '/telemetry/frames',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
//# sourceMappingURL=sdk.gen.js.map